import { render, staticRenderFns } from "./OilPrice.vue?vue&type=template&id=95059dd8&scoped=true"
import script from "./OilPrice.vue?vue&type=script&lang=js"
export * from "./OilPrice.vue?vue&type=script&lang=js"
import style0 from "./OilPrice.vue?vue&type=style&index=0&id=95059dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95059dd8",
  null
  
)

export default component.exports